class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false, true);
    
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.dispatchVariantChange();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  dispatchVariantChange() {
    document.dispatchEvent(
      new CustomEvent(
        'variant-change',
        {
          bubbles: true,
          variant: this.currentVariant,
          detail: {
            variant: this.currentVariant
          }
        }
      )
    );
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-sticky-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      // update current variant on the Back in Stock button, if any
      if (productForm.querySelector('#BIS_trigger')) productForm.querySelector('#BIS_trigger').setAttribute('data-variant-id',this.currentVariant.id);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        // Update price on the Summary & Sticky bar
        const priceID = `price-${this.dataset.section}`;
        const priceDestination = document.getElementById(priceID);
        const priceDestinationSticky = document.querySelector('[data-product-sticky-price]');
        const priceSource = html.getElementById(priceID);
        
        if (priceSource) {
          priceDestination ? priceDestination.innerHTML = priceSource.innerHTML : '';
          priceDestinationSticky ? priceDestinationSticky.innerHTML = priceSource.innerHTML : '';
        }
        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        
        if (this.currentVariant) {
          // Back in Stock app - Change visibility class according to the current variant availability
          const backInStockButton = this.closest('[data-product-info]').querySelector('#BIS_trigger');
          if (backInStockButton) {
            const addButton = this.closest('[data-product-info]').querySelector('[name="add"]');
            this.toggleAddButton(!this.currentVariant.available, window.variantStrings.backInStock);
            if (this.currentVariant.available) {
              backInStockButton.classList.add('hidden');
              addButton.classList.remove('button--to-overwrite');
            }
            else {
              backInStockButton.classList.remove('hidden');
              backInStockButton.removeAttribute('disabled');
              addButton.classList.add('button--to-overwrite');
            }

          }
          // Default behavior without Back in Stock app
          else {
            this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
          }
        }

        // Update variants in Summary & Sticky (radio & select) - Selected variant, stock information,...
        function variantsUpdate (elementSelector) {
          const elementSource = html.querySelector(elementSelector);
          const elementDestination = document.querySelector(elementSelector);
          if (elementSource) {
            elementDestination ? elementDestination.innerHTML = elementSource.innerHTML : '';
          }
        }
        variantsUpdate('[data-product-variant-radios]');
        variantsUpdate('[data-product-sticky-variant-radios]');
        variantsUpdate('[data-product-sticky-variant-selects]');

        // Update the inventory quantity hidden input
        const inventoryQtyDestination = document.querySelector(`#product-form-${this.dataset.section}`).querySelector('input[name="inventory_quantity"]');
        const inventoryQtySource = html.querySelector(`#product-form-${this.dataset.section}`).querySelector('input[name="inventory_quantity"]');
        inventoryQtyDestination.value = inventoryQtySource.value;
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true, firstToggle = false) {

    // firstToggle - there are always 2 toggles on variant change - one to disable the button (onVariantChange), the second to enable/disable it accordingly (renderProductInfo)

    // check the default add to cart and sticky add to cart buttons
    const addButtons = document.querySelector('[data-product-buy-buttons]').querySelectorAll('[name="add"]');

    addButtons.forEach(addButton => {
      if (!addButton) return;

      const backInStockButton = this.closest('[data-product-info]').querySelector('#BIS_trigger');
      // used for the BIS functionality
      const isStickyButton = backInStockButton && addButton.hasAttribute('data-add-to-cart-button-sticky') && !firstToggle;
  
      if (disable) {
        addButton.setAttribute('disabled', true);
        if (text) addButton.querySelector('[data-add-to-cart-text]').textContent = text;
        // disable the BIG button until it's ready
        if (backInStockButton && firstToggle) backInStockButton.setAttribute('disabled', true);
        // enable the Add to cart button from the sticky bar if the product is not available (its trigger will open the BIS pop up)
        if (isStickyButton) {
          addButton.removeAttribute('disabled');
          addButton.classList.add('button--notify-me');
        }
      } else {
        addButton.removeAttribute('disabled');
        addButton.querySelector('[data-add-to-cart-text]').textContent = window.variantStrings.addToCart;
        // remove the Notify me class when the product is available
        if (isStickyButton) addButton.classList.remove('button--notify-me');
      }
  
      if (!modifyClass) return;
    });

    // disable recipient Gift card button if the variant is sold out
    const recipientGiftCardTrigger = document.querySelector('[data-recipient-form-trigger]');
    if (recipientGiftCardTrigger) {
      disable ? recipientGiftCardTrigger.setAttribute('disabled', true) : recipientGiftCardTrigger.removeAttribute('disabled');
    }
  }

  setUnavailable() {
    // check the default add to cart and sticky add to cart buttons
    const addButtons = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButtons) return;
    
    addButtons.forEach(addButton => {
      addButton.textContent = window.variantStrings.unavailable;
      document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
    });
  }

  getVariantData() {
    let variantJSONData;
    if (this.querySelector('[type="application/json"]') != null) {
      variantJSONData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    }
    else {
      variantJSONData = JSON.parse(document.querySelector('[data-product-sticky-variants]').querySelector('[type="application/json"]').textContent);
    }
    this.variantData = this.variantData || variantJSONData;
    return this.variantData;
  }
}

if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}

class VariantSelects extends VariantRadios {
  constructor() {
    super();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}